import { createIconComponent } from '../../factory/create-icon-component';
export const EditIcon = createIconComponent(
  'EditIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0001 4.00004L6.37023 13.6298C5.86092 14.1391 5.60627 14.3938 5.40392 14.6839C5.22432 14.9414 5.07566 15.2192 4.96101 15.5115C4.83185 15.8408 4.76122 16.1939 4.61997 16.9002L4 20.0001L7.09986 19.3801C7.80613 19.2388 8.15927 19.1682 8.48856 19.039C8.78084 18.9244 9.05861 18.7757 9.31613 18.5961C9.60626 18.3938 9.86091 18.1392 10.3702 17.6299L10.3702 17.6299L20.0001 8C20.5453 7.45478 20.8179 7.18218 20.9636 6.8881C21.2409 6.32854 21.2409 5.67157 20.9636 5.112C20.8179 4.81793 20.5453 4.54531 20.0001 4.00009C19.4549 3.45485 19.1823 3.18223 18.8882 3.03649C18.3286 2.75918 17.6716 2.75917 17.1121 3.03647C16.818 3.18221 16.5454 3.45482 16.0001 4.00004Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5.00006C15 7.2092 16.7909 9.00006 19 9.00006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
